export const COLORS = {
  bg: "#0F0F1A",
  bgShowcase: "#FFFFFF",
  text: "#FFFFFF",
  textDark: "#000000",
  accent: "#3B82F6",
  accentLight: "#60A5FA",
  accentDark: "#2563EB",
  gray: "#6B7280",
  grayLight: "#F3F4F6",
} as const;
